import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Plus, X, Receipt, ScanLine } from "lucide-react";

export default function FloatingActions() {
  const nav = useNavigate();
  const loc = useLocation();
  const { session, isAdmin, isVendedor } = useAuth();
  const [open, setOpen] = useState(false);

  if (!session) return null;
  // Esconde em telas de autenticação
  if (loc.pathname === "/login" || loc.pathname === "/staff-login" || loc.pathname === "/register") return null;

  // Só vendedor ou admin podem criar venda / escanear
  const canCreate = isAdmin || isVendedor;
  if (!canCreate) return null;

  const go = (to) => {
    setOpen(false);
    nav(to);
  };

  return (
    <>
      {/* Backdrop quando aberto */}
      {open && (
        <div
          data-testid="fab-backdrop"
          onClick={() => setOpen(false)}
          className="fixed inset-0 bg-black/30 z-40 backdrop-blur-sm animate-fade-in"
        ></div>
      )}

      <div
        className="fixed right-4 z-50 flex flex-col items-end gap-3"
        style={{ bottom: "calc(72px + env(safe-area-inset-bottom, 0px))" }}
      >
        {/* Opções que aparecem quando o FAB tá aberto */}
        {open && (
          <>
            <button
              data-testid="fab-nova-venda"
              onClick={() => go("/nova-venda")}
              className="h-12 pl-5 pr-4 rounded-full bg-white border-2 border-stone-200 shadow-lg text-stone-900 font-bold inline-flex items-center gap-2 animate-slide-up"
              style={{ animationDelay: "40ms" }}
            >
              <span className="text-sm whitespace-nowrap">Nova Venda</span>
              <span className="w-9 h-9 rounded-full bg-[color:var(--terracotta)] text-white flex items-center justify-center">
                <Receipt className="w-4 h-4" strokeWidth={2.4} />
              </span>
            </button>
            <button
              data-testid="fab-escanear"
              onClick={() => go("/scan")}
              className="h-12 pl-5 pr-4 rounded-full bg-white border-2 border-stone-200 shadow-lg text-stone-900 font-bold inline-flex items-center gap-2 animate-slide-up"
              style={{ animationDelay: "0ms" }}
            >
              <span className="text-sm whitespace-nowrap">Escanear Carnê</span>
              <span className="w-9 h-9 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                <ScanLine className="w-4 h-4" strokeWidth={2.4} />
              </span>
            </button>
          </>
        )}

        {/* Botão principal + / X */}
        <button
          data-testid="fab-main"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Fechar atalhos" : "Abrir atalhos"}
          className={`w-14 h-14 rounded-full shadow-xl flex items-center justify-center transition-all duration-200 ${
            open
              ? "bg-stone-800 text-white rotate-45 scale-105"
              : "bg-[color:var(--terracotta)] text-white hover:scale-105 active:scale-95"
          }`}
          style={{ boxShadow: "0 10px 24px -6px rgba(200,90,50,0.5)" }}
        >
          {open ? <X className="w-6 h-6" strokeWidth={2.5} /> : <Plus className="w-7 h-7" strokeWidth={2.6} />}
        </button>
      </div>
    </>
  );
}
